// extracted by mini-css-extract-plugin
export default {"profile_image":"Picture_profile_image__C1n9Q"};